/* eslint-disable */
import React, { useEffect } from 'react';
import { connect } from 'dva';
import { registerWindowFn } from '@/utils/bridge';
import {
  checkLogin,
  getAndUpdateAppInfo,
  getAndUpdateNotificationPermission,
  getProxyAddressInfo,
  getCookie,
} from '@/utils/utils';
import { H5_PAGE_RESUMED_STATE } from '@/constant';
// [20250418] 修复移动端点击事件不生效的问题
import FastClick from 'fastclick';
// 【20231106】修复react-countup依赖报错Object.fromEntries is not a function的问题
import 'polyfill-object.fromentries';

// import VConsole from 'vconsole';
// new VConsole();

const VCONSOLE_WHITELIST = [
  '1948',
  '868782423',
  '831001633',
  '794744221',
  '823626091',
  '753250918',
]; // 在这里添加需要开启调试的用户 ID

const BasicLayout = ({ children, user: { hasLogin } }) => {
  useEffect(() => {
    const setupVConsole = async () => {
      if (hasLogin) {
        try {
          let userId = await getCookie('userid');
          console.log('userId', userId);
          if (VCONSOLE_WHITELIST.includes(userId)) {
            const VConsole = require('vconsole');
            const vConsole = new VConsole();

            // Clean up on unmounting component
            return () => {
              vConsole.destroy();
            };
          }
        } catch (error) {
          console.error('Error setting up VConsole:', error);
        }
      }
    };

    setupVConsole();

    // Return cleanup function outside of async function
    return () => {};
  }, [hasLogin]);

  // h5页面隐藏/出现原生回调
  const h5PageVisibilityChange = state => {
    if (state === H5_PAGE_RESUMED_STATE) {
      getAndUpdateNotificationPermission();
    }
  };

  useEffect(() => {
    FastClick.attach(document.body);
    getProxyAddressInfo();
    getAndUpdateAppInfo();
    checkLogin();
    registerWindowFn('checkLogin', checkLogin);
    registerWindowFn('h5PageVisibilityChange', h5PageVisibilityChange);
  }, []);

  return <React.Fragment>{children}</React.Fragment>;
};

export default connect(({ user }) => ({ user }))(BasicLayout);
